import { render, staticRenderFns } from "./BatchNotFound.vue?vue&type=template&id=c4c93fde&"
import script from "./BatchNotFound.vue?vue&type=script&lang=js&"
export * from "./BatchNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports